/**
 * The free-pilot dialog, opened from anywhere on the page.
 *
 * Six links ask for the pilot — two in the nav, one in the nav's phone sheet,
 * one in the hero, one under the features, and two the demo call leaves behind
 * when it ends. They sit in four different subtrees, and two of them are inside
 * the call provider, so a context would have to wrap the whole page to reach
 * them. An event costs nothing and reaches all six wherever they end up.
 */
const OPEN = "hireos:pilot-open";

/** Opens the pilot dialog. Safe to call before the dialog has mounted. */
export function openPilot() {
  dispatchEvent(new Event(OPEN));
}

/** Subscribes to open requests; returns the unsubscribe. */
export function onPilotOpen(fn: () => void) {
  addEventListener(OPEN, fn);
  return () => removeEventListener(OPEN, fn);
}

/**
 * Props for a link or button that opens the dialog. The CTAs are anchors in
 * the markup and stay anchors — the href is kept as the page's own top so a
 * middle-click or a crawler has somewhere to go, and the click is intercepted.
 */
export const pilotProps = {
  href: "#",
  onClick: (e: React.MouseEvent) => {
    e.preventDefault();
    openPilot();
  },
};
